import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface InvoiceState {
  rcboInvoiceCount: number;
  invoiceTasksCount: number;
  refreshCountFlag: boolean;
}

// Initial state
const initialState: InvoiceState = {
  rcboInvoiceCount: 0,
  invoiceTasksCount: 0,
  refreshCountFlag: true,
};

const invoiceCountSlice = createSlice({
  name: "invoiceCount",
  initialState,
  reducers: {
    setRcboInvoiceCount: (state, action: PayloadAction<number>) => {
      state.rcboInvoiceCount = action.payload;
    },
    setInvoiceTasksCount: (state, action: PayloadAction<number>) => {
      state.invoiceTasksCount = action.payload;
    },
    setAllCounts: (
      state,
      action: PayloadAction<{ rcboInvoiceCount: number; invoiceTasksCount: number }>
    ) => {
      state.rcboInvoiceCount = action.payload.rcboInvoiceCount;
      state.invoiceTasksCount = action.payload.invoiceTasksCount;
    },
    resetInvoiceCounts: (state) => {
      state.rcboInvoiceCount = 0;
      state.invoiceTasksCount = 0;
    },
    setRefreshCountFlag: (state, action: PayloadAction<boolean>) => {
      state.refreshCountFlag = action.payload;
    },
  },
});

// Export actions and reducer
export const {
  setRcboInvoiceCount,
  setInvoiceTasksCount,
  setAllCounts,
  resetInvoiceCounts,
  setRefreshCountFlag,
} = invoiceCountSlice.actions;

export default invoiceCountSlice.reducer;
